<template id="mdm-form-page">
  <section>
    <b-modal
        ref="download-format-modal"
        title="Download data"
        centered
        @shown="onDownloadFormatModalShown"
    >
      <div class="download-format-modal-body">
        <p class="text-muted small mb-2">You are about to download:</p>
        <div class="d-flex align-items-start mb-2">
          <i class="fa fa-file-o text-secondary mt-1 mr-2" aria-hidden="true"></i>
          <div>
            <div class="font-weight-bold">{{ downloadModalFileName }}</div>
            <div class="download-format-meta small text-muted pl-0 mt-1">
              <div>which is: {{ downloadModalTypeLine }}</div>
              <div>from: {{ downloadModalFromLine }}</div>
            </div>
          </div>
        </div>

        <p class="font-weight-bold mb-2 mt-3">Choose download format:</p>
        <b-form-radio-group
            v-model="downloadFormatChoice"
            stacked
            class="download-format-radios"
        >
          <b-form-radio value="xlsx">XLSX (Excel)</b-form-radio>
          <b-form-radio value="csv">CSV</b-form-radio>
        </b-form-radio-group>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="primary" class="mr-2" @click="confirmDownloadFormatModal">OK</b-button>
          <b-button variant="outline-secondary" @click="cancelDownloadFormatModal">Cancel</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
        ref="download-modal"
        title="Downloading Data"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        hide-footer
    >
      <div class="text-center">
        <b-spinner variant="primary" class="mb-3"></b-spinner>
        <p class="mb-0">Preparing your download... Please wait.</p>
      </div>
    </b-modal>

    <div>
      <div class="m-1">
        <div class="card mdm-form-report-card shadow-sm">
          <div
              class="card-header mdm-form-card-header d-flex flex-wrap align-items-center justify-content-between text-left py-2 px-2">
            <div class="mdm-form-header-title mb-1 mb-md-0 d-flex align-items-center flex-wrap">
              <span class="d-inline-flex align-items-center mr-2">
                <i
                :class="
                  screenletTitleInfo
                    ? 'fa fa-info-circle custom-icon'
                    : 'fa fa-info-circle'
                "
                :style="{ color: screenletTitleInfo ? '#ffffff' : 'inherit' }"
                ref="tooltipIcon"
                v-b-tooltip.hover.right.html="{
                  title: screenletTitleInfo,
                  customClass: 'my-custom-tooltip',
                  autoHide: false,
                }"
                @mouseenter="showTooltip"
                @mouseleave="hideTooltip"
              >
              </i>
                <span>{{ formTitle }}</span>
              </span>
              <!-- <b-badge v-if="rowsdata.length" variant="light" class="mdm-row-count-badge border mb-1 mb-md-0">
                {{ rows === rowsdata.length ? rows + ' rows' : rows + ' / ' + rowsdata.length + ' rows' }}
              </b-badge> -->
            </div>
            <div
                class="d-flex align-items-stretch align-items-md-center flex-wrap justify-content-end flex-grow-1 flex-md-grow-0 mdm-form-header-toolbar">
              <div class="input-group input-group-sm mdm-form-search mr-md-2 mb-1 mb-md-0">
                <div class="input-group-prepend">
                  <span class="input-group-text mdm-search-addon" title="Search all columns">
                    <i class="fa fa-search text-muted" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                    type="search"
                    v-model="filterSearchInput"
                    placeholder="Search all columns…"
                    class="form-control form-control-sm"
                    autocomplete="off"
                    aria-label="Search report"
                    @keydown.esc.prevent="clearReportSearch"
                >
                <div v-if="filterSearchInput" class="input-group-append">
                  <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm mdm-search-clear"
                      title="Clear search"
                      aria-label="Clear search"
                      @click="clearReportSearch"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div class="d-flex align-items-center mdm-form-header-icons flex-shrink-0">
                <span
                    v-for="(ai, index) in currentRepActionIconsData"
                    :key="index"
                    class="mdm-form-action-icon-wrap"
                    @click="handleRepActionIcon(ai.functionName, index, ai)"
                >
                  <i
                      :id="ai.iconId"
                      :class="ai.iconOnchangeClass"
                      :title="ai.iconOnchangeTooltip"
                  ></i>
                </span>
              </div>
            </div>
          </div>
          <div class="card-body mdm-report-card-body">

            <!--Filters-->
            <div class="report-filters rounded" v-if="dimSelectDpValues.length > 0">
              <div v-for="filter in dimSelectDpValues"
                   :key="`filter-${filter.key}`"
                   class="filter-item">
                <label class="form-label filter-label mb-0">{{ filter.displayName }}</label>
                <multiselect
                    :ref="`mdm-filter-${filter.key}`"
                    v-model="selectVal[filter.key]"
                    :options="getOptionsForFilter(filter.key)"
                    :limit="1"
                    :multiple="true"
                    select-label="Select"
                    deselect-label="Unselect"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :append-to-body="true"
                    :clear-on-close="true"
                    style="min-height: 20px"
                    placeholder="Select Option"
                    class="compact-multiselect"
                    @input="onFilterSelectionChange(filter.key)"
                >
                </multiselect>
              </div>
              <button
                  v-if="hasActiveFilters"
                  type="button"
                  class="btn btn-sm btn-outline-secondary clear-filter-btn"
                  @click="clearAllFilters"
              >
                Clear Filters
              </button>
            </div>
            <!--table-->
            <div class="grid-container mdm-report-grid">
              <div class="report-table-wrapper" :style="tableWrapperStyle">
                <ValidationObserver
                    ref="mdmReportObserver"
                    tag="div"
                    class="mdm-report-vee-observer"
                    v-slot="{ invalid }"
                >
                <table
                    id="mdm-form-report-table"
                    ref="mdmFormReportTable"
                    class="table table-bordered table-hover report-data-table"
                    :style="tableLayoutStyle"
                >
                  <colgroup>
                    <col class="mdm-col-action">
                    <col v-for="(col, index) in columns"
                         :key="'colgroup-' + index"
                         :style="mdmIsStickyAnchorDisplayName(col) ? snoColumnWidthStyle : {}">
                  </colgroup>
                  <thead class="thead-dark">
                  <tr class="text-center mdm-header-row">
                    <th class="action-col">Action
                      <a href="#" class="mdm-sort-trigger" @click.prevent><i class="fa fa-sort"></i></a>
                    </th>
                    <th v-for="(col, index) in columns" v-bind:key="index"
                        :class="{
                          'sno-col': mdmIsStickyAnchorDisplayName(col),
                          'sticky-follow-col': isFollowStickyColumn(index)
                        }"
                        :style="stickyFollowColumnStyle(index)">
                      {{ col }}
                      <span v-if="columnsInfo[index]['fieldIsNullable']==='N'" class="text-danger">*</span>
                      <a href="#" class="mdm-sort-trigger" @click.prevent="sortBy(Rcolumns[index])">
                        <i class="fa"
                           v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : (sortOrder === 'desc' ? 'fa-sort-amount-up-alt' : 'fa-sort')) : 'fa-sort' "
                           v-bind:style="[Rcolumns[index]===sortKey && (sortOrder === 'asc' || sortOrder === 'desc') ? {'color':'#facc15'} : {'color':'#e2e8f0'}]"></i>
                      </a>
                    </th>
                  </tr>
                  </thead>
                  <tbody
                      v-for="(rowd, index) in paginatedItems"
                      :key="rowLoopKey(rowd, index)"
                  >
                    <mdm-form-report-data-row
                        :rowd="rowd"
                        :row-index="index"
                        :columns="columns"
                        :rcolumns="Rcolumns"
                        :columns-info="columnsInfo"
                        :editable-id="editableId"
                        :show-inputfield="showInputfield"
                        :cell-layout="mdmDataRowCellLayout"
                        :row-actions-enabled="isMdmRowActionAllowed(rowd)"
                        :mdm-vee-invalid="invalid"
                        :mdm-draft-active="showInput || showInputfield"
                        @add="showRow"
                        @edit="edit"
                        @save-edit="validateEditRow(rowInsert)"
                        @cancel="hideR"
                    />
                    <mdm-form-report-edit-row
                        v-if="showInputfield && rowd.syspk == editableId"
                        :row-insert="rowInsert"
                        :columns="columns"
                        :rcolumns="Rcolumns"
                        :columns-info="columnsInfo"
                        :cell-layout="mdmDataRowCellLayout"
                    />
                    <mdm-form-report-insert-row
                        v-if="showInput && rowd.syspk === savetableId"
                        :row-edit="rowEdit"
                        :columns="columns"
                        :rcolumns="Rcolumns"
                        :columns-info="columnsInfo"
                        :anchor-row="rowd"
                        :cell-layout="mdmDataRowCellLayout"
                        :mdm-vee-invalid="invalid"
                    />
                  </tbody>
                </table>
                </ValidationObserver>
              </div>
              <!-- Pagination controls -->
              <div v-if="showPagination" class="mdm-pagination-bar d-flex flex-wrap align-items-center justify-content-center mt-2 px-1">
                <div class="d-flex align-items-center flex-wrap mdm-per-page-group">
                  <span class="small text-muted mb-0">Rows per page</span>
                  <b-form-select
                      v-model="perPage"
                      :options="perPageSelectOptions"
                      size="sm"
                      class="mdm-per-page-select w-auto"
                  />
                </div>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    align="center"
                    class="mb-0"
                    aria-controls="mdm-form-report-table"
                ></b-pagination>
                <p class="small text-muted mb-0">
                  Showing
                  <strong>{{ paginationFrom }}</strong>–<strong>{{ paginationTo }}</strong>
                  of <strong>{{ rows }}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-xl" size="xl" ref="validate-update-row-box" @ok="updateRecord()" :title="formTitle">

      <b-form-group>
        <!--<b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                required
        ></b-form-input>-->
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="thead-dark">
            <tr class="text-center">

              <th v-for="(col, index) in previewColumns" v-bind:key="previewColumnKeys[index]">
                {{ col }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>

              <td style="color:blue" v-for="(key) in previewColumnKeys" v-bind:key="key">
                {{ rowd[key] }}

              </td>
            </tr>
            <template v-if="rowd['syspk']==20">
              <tr v-for="er in 2" v-bind:key="er">

                <td style="color:darkgoldenrod" v-for="key in previewColumnKeys" v-bind:key="key">
                  {{ rowd[key] }}
                </td>


              </tr>
            </template>

            </tbody>
          </table>

        </div>
      </b-form-group>

    </b-modal>
    <b-modal id="modal-xl" size="xl" ref="validate-insert-row-box" @ok="insertRecord()" ok-title="Accept"
             :title="formTitle">

      <b-form-group
          :label="dedupData.length>0?'Check the rows for duplication':'No Possible Duplicate Record found. Please validate and accept for insertion'">
        <!--<b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                required
        ></b-form-input>-->
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="thead-dark">
            <tr class="text-center">

              <th v-for="(col, index) in previewColumns" v-bind:key="previewColumnKeys[index]">
                {{ col }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>

              <td style="color:blue" v-for="key in previewColumnKeys" v-bind:key="key">
                {{ rowdIns[key] }}

              </td>
            </tr>
            <template v-if="dedupData.length>0">
              <tr v-for="er in dedupData" v-bind:key="er">

                <td style="color:darkgoldenrod" v-for="key in previewColumnKeys" v-bind:key="key">
                  {{ er[key] }}
                </td>


              </tr>
            </template>

            </tbody>
          </table>

        </div>
      </b-form-group>

    </b-modal>
    <b-modal ref="success-box" :hide-footer="true" :title="formTitle" cancel-disabled ok-disabled>
      <b-form-group label="">
        <h4 style="color:darkblue">Record Added Successfully.</h4>
      </b-form-group>
    </b-modal>
    <div>
      <!-- Your existing UI -->
      <modal
          v-if="showErrorModal"
          :isVisible="showErrorModal"
          @close="showErrorModal = false"
          :title="title"
      >
        <!--        <span>Selected option is not supported.</span>-->
      </modal>
    </div>
  </section>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import { runFetchCsvExport } from '@/common/functions'
import 'vue2-datepicker/index.css';
import Modal from "@/components/Modal.vue";
import MdmFormReportDataRow from '@/components/reports/mdm-form-report-data-row.vue'
import MdmFormReportInsertRow from '@/components/reports/mdm-form-report-insert-row.vue'
import MdmFormReportEditRow from '@/components/reports/mdm-form-report-edit-row.vue'
import {markRaw} from "vue"
import Multiselect from 'vue-multiselect/src/Multiselect'
import {extend, ValidationObserver} from 'vee-validate'
import {required, email, numeric} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_} is required',
})
extend('email', {
  ...email,
  message: 'Enter a valid email address.',
})
extend('numeric', {
  ...numeric,
  message: 'Must be numeric.',
})
extend('indianPhone', {
  validate: value =>
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      /^[6-9][0-9]{9}$/.test(String(value)),
  message: 'Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.',
})

/** Stored on API rows but not shown as grid columns (permissions, etc.). */
const MDM_ROW_META_KEYS = new Set(['is_row_editable'])

/** Audit / system columns hidden in validate previews (still shown in main grid). */
const MDM_PREVIEW_EXCLUDED_KEYS = new Set([
  'created_by',
  'create_timestamp',
  'updated_by',
  'update_timestamp',
])

/**
 * Grid `formFieldDisplay` titles that anchor the sticky block after Action (`left` stacking).
 * When the API uses Syspk instead of S.No, sticky must still resolve the correct index.
 */
const MDM_STICKY_ANCHOR_DISPLAY_NAMES = Object.freeze(['S.No', 'Syspk'])
const MDM_STICKY_ANCHOR_DISPLAY_SET = new Set(MDM_STICKY_ANCHOR_DISPLAY_NAMES)

function mdmStickyAnchorColumnIndex(columns) {
  if (!Array.isArray(columns)) return -1
  for (const name of MDM_STICKY_ANCHOR_DISPLAY_NAMES) {
    const i = columns.indexOf(name)
    if (i >= 0) return i
  }
  return -1
}

function filterDisplayedDataKeys(keys) {
  return keys.filter((k) => !MDM_ROW_META_KEYS.has(k))
}

export default {
  name: 'simple-report-page',
  components: {
    Modal,
    Multiselect,
    ValidationObserver,
    MdmFormReportDataRow,
    MdmFormReportInsertRow,
    MdmFormReportEditRow,
  },
  provide() {
    return {
      mdmFormReport: this,
    }
  },
  data: function () {
    return {
      title: "",
      showErrorModal: false,
      rowInsert: [],
      dateErrors: {},
      errors: {},
      emailField: '',
      showInputfield: '',
      editableId: [],
      showInput: '',
      savetableId: [],
      hideRow: [],
      rowd: [],
      rowdIns: [],
      columnsInfo: [],
      rowEdit: [],
      listboxData: {},
      /** LOV row sets keyed by listbox SQL — used only for `Select Only` cascade (not for `Select Only LOV`). */
      listboxLovRows: {},
      /** Cascade groups: only `Select Only` columns sharing the same listbox SQL. */
      lovSqlCascadeGroups: [],
      dedupData: [],
      mfgNameList: [],
      brandNameList: [],

      message: '',
      name: '',


      output: [],
      formTitle: '',
      formMessage: '',
      columns: [],
      filters: [],
      keys: [],
      rowsdata: [],
      sortKey: '',
      sortOrder: '',
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      /** Applied to `filteredItems` after debounce (see `filterSearchInput`). */
      filterValue: '',
      selectVal: {},
      /** Bound to search input; heavy filtering runs from `filterValue`, not on every keystroke. */
      filterSearchInput: '',
      /** Ch unit width for S.No column; updated when filtered set changes (avoids scanning all rows in a computed). */
      snoColumnCh: 7,
      /** Measured thead widths (px) so sticky `left` matches real column sizes (follow cols grow past 150px with nowrap). */
      measuredStickyWidths: {snoPx: 0, follow0Px: 0},
      debouncedSyncFilterValue: null,
      currentPage: 1,
      perPage: 500,
      currentRepActionIconsData: [],
      apiData: null,
      icons: [],
      downloadSqlId: null,
      pendingDownloadFormat: 'xlsx',
      downloadFormatChoice: 'xlsx',
      downloadLoading: false,
      iconOnChangeFlag: [],
      showFSButton: true,
      screenletTitleInfo: "",
    }
  },
  created: function () {
    this._rowSelectOptionsCache = Object.create(null)
    this.debouncedSyncFilterValue = _.debounce(() => {
      this.filterValue = this.filterSearchInput
    }, 320)
    this.loadReportConfig()
    this.listenToRouter()
  },
  mounted() {
    this._resizeStickyBound = () => this.scheduleStickyColumnMeasure()
    window.addEventListener('resize', this._resizeStickyBound, {passive: true})
  },
  beforeDestroy() {
    if (this._resizeStickyBound) {
      window.removeEventListener('resize', this._resizeStickyBound)
    }
    if (this.debouncedSyncFilterValue && this.debouncedSyncFilterValue.cancel) {
      this.debouncedSyncFilterValue.cancel()
    }
    if (this._stickyMeasureTimer) {
      clearTimeout(this._stickyMeasureTimer)
      this._stickyMeasureTimer = null
    }
  },
  watch: {
    filterSearchInput() {
      if (this.debouncedSyncFilterValue) {
        this.debouncedSyncFilterValue()
      }
    },
    filteredItems: {
      handler(val) {
        this.currentPage = 1
        this.updateSnoColumnCh(val)
        this.scheduleStickyColumnMeasure()
      },
      immediate: true,
    },
    columns: {
      handler() {
        this.scheduleStickyColumnMeasure()
      },
    },
    showInputfield() {
      this.scheduleStickyColumnMeasureBurst()
    },
    showInput() {
      this.scheduleStickyColumnMeasureBurst()
    },
    editableId() {
      this.scheduleStickyColumnMeasureBurst()
    },
    savetableId() {
      this.scheduleStickyColumnMeasureBurst()
    },
    perPage() {
      const maxP = Math.max(1, Math.ceil(this.rows / this.perPage) || 1)
      if (this.currentPage > maxP) {
        this.currentPage = maxP
      }
    },
  },
  computed: {
    rows() {
      return this.filteredItems.length
    },
    tableMinWidth() {
      const totalCols = (Array.isArray(this.columns) ? this.columns.length : 0) + 1 // +1 for action column
      return Math.max(totalCols * 132, 1280)
    },
    /** Full width inside wrapper; minWidth triggers horizontal scroll only when the card is narrower than content. */
    tableLayoutStyle() {
      const m = this.measuredStickyWidths
      const snoW = m.snoPx > 0 ? `${m.snoPx}px` : `${this.snoColumnCh}ch`
      const follow0 = m.follow0Px > 0 ? `${m.follow0Px}px` : '0px'
      return {
        width: '100%',
        minWidth: `${this.tableMinWidth}px`,
        '--mdm-sno-col-width': snoW,
        '--mdm-sticky-follow-0-px': follow0,
      }
    },
    /** Narrow S.No to longest visible value (+ room for header/sort); updates when filters/search change. */
    snoColumnWidthStyle() {
      const m = this.measuredStickyWidths
      if (m.snoPx > 0) {
        return {width: `${m.snoPx}px`, minWidth: `${m.snoPx}px`}
      }
      const ch = this.snoColumnCh
      return {width: `${ch}ch`, minWidth: `${ch}ch`}
    },
    /** Stable per-column sticky flags/styles for data rows only (no dependency on rowEdit / rowInsert). */
    mdmDataRowCellLayout() {
      const n = this.columns.length
      const flags = new Array(n)
      const styles = new Array(n)
      for (let i = 0; i < n; i++) {
        flags[i] = this.isFollowStickyColumn(i)
        styles[i] = this.stickyFollowColumnStyle(i)
      }
      return {flags, styles}
    },
    paginationFrom() {
      if (this.rows === 0) {
        return 0
      }
      return (this.currentPage - 1) * this.perPage + 1
    },
    paginationTo() {
      return Math.min(this.currentPage * this.perPage, this.rows)
    },
    perPageSelectOptions() {
      return [
        {value: 50, text: '50'},
        {value: 100, text: '100'},
        {value: 200, text: '200'},
        {value: 500, text: '500'},
      ]
    },
    showPagination() {
      return this.rows > this.perPage
    },
    hasVisibleFilterBar() {
      return Array.isArray(this.dimSelectDpValues) && this.dimSelectDpValues.length > 0
    },
    tableWrapperStyle() {
      const topReservePx = this.$store.state.bannerStatus ? 320 : 260
      const filtersReservePx = this.hasVisibleFilterBar ? -50 : -130
      const paginationReservePx = this.showPagination ? 50 : 0
      const tableHeightPx = topReservePx + filtersReservePx + paginationReservePx
      return {
        height: `calc(100dvh - ${tableHeightPx}px)`,
        maxHeight: `calc(100dvh - ${tableHeightPx}px)`,
        minHeight: '220px'
      }
    },
    downloadModalPreviewBase() {
      const uid = this.$store.state.user && this.$store.state.user.userId
      const title = this.formTitle || 'export'
      if (uid == null) return 'export'
      return `${uid}_${title}_${moment().format('YYYY-MM-DD_hhmm')}`
    },
    downloadModalFileName() {
      const ext = this.downloadFormatChoice === 'xlsx' ? 'xlsx' : 'csv'
      return `${this.downloadModalPreviewBase}.${ext}`
    },
    downloadModalTypeLine() {
      return this.downloadFormatChoice === 'xlsx'
        ? 'Microsoft Excel Workbook (.xlsx)'
        : 'Comma-separated values (.csv)'
    },
    downloadModalFromLine() {
      const name = this.formTitle ? String(this.formTitle) : 'export'
      return name.replace(/\//g, '-')
    },
    hasActiveFilters() {
      return this.dimSelectDpValues.some(filter => {
        const selected = this.selectVal[filter.key]
        return Array.isArray(selected) && selected.length > 0
      })
    },
    snoColumnIndex() {
      return mdmStickyAnchorColumnIndex(this.columns)
    },
    previewColumnInfos() {
      if (!Array.isArray(this.columnsInfo)) return []
      return this.columnsInfo.filter(
          (c) => c && c.formColumnName && !MDM_PREVIEW_EXCLUDED_KEYS.has(c.formColumnName),
      )
    },
    previewColumns() {
      return this.previewColumnInfos.map((c) => c.formFieldDisplay)
    },
    previewColumnKeys() {
      return this.previewColumnInfos.map((c) => c.formColumnName)
    },
    paginatedItems() {
      // If less than 1000 records, just return all
      if (this.filteredItems.length <= this.perPage) {
        return this.filteredItems
      }
      let start = (this.currentPage - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      return filterDisplayedDataKeys(Object.keys(this.rowsdata[0]))
    },
    "orderedData": function () {
      let result = this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      if (!this.sortKey || !this.sortOrder) {
        return result
      }
      return _.orderBy(result, [this.sortKey], [this.sortOrder])
    },
    mfgName() {
      return (key1) => {
        console.log("mfg code passed", key1, this.mfgNameList.filter(f => f.c_mfac_code == 'MF0001')[0].c_mfac_name)
        if (key1) {
          return [this.mfgNameList.filter(f => f.c_mfac_code == key1)[0].c_mfac_name]
        } else
          return null

      }
    },
    brandName() {
      return (key1) => {
        console.log("mfg code passed", key1)
        if (key1) {
          return [this.brandNameList.filter(f => f.c_brand_code == key1)[0].c_brand_name]
        } else
          return null

      }
    },
    filteredItems() {
      const dimFilters = this.dimSelectDpValues
      let result = this.rowsdata
      if (dimFilters.length > 0) {
        result = result.filter(item => {
          for (let fi = 0; fi < dimFilters.length; fi++) {
            const key = dimFilters[fi].key
            const sel = this.selectVal[key]
            if (sel && sel.length > 0 && !sel.includes(item[key])) {
              return false
            }
          }
          return true
        })
      }
      const q = this.filterValue
      if (q) {
        const qLower = q.toLowerCase()
        result = result.filter(obj => {
          for (const key in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
              continue
            }
            if (MDM_ROW_META_KEYS.has(key)) {
              continue
            }
            const v = obj[key]
            if (v != null && String(v).toLowerCase().includes(qLower)) {
              return true
            }
          }
          return false
        })
      }
      if (!this.sortKey || !this.sortOrder) {
        return markRaw(result)
      }
      return markRaw(_.orderBy(result, [this.sortKey], [this.sortOrder]))
    },
    getValues() {
      return (key1, x) => {
        // console.log("getValues ====> item", key1, x)
        var filteredData = this.example.filter((item) => {

          for (let kkk in x) { // loop over the keys of x
            //console.log("getValues >>>> ",kkk)

            if (x[kkk] && x[kkk].length > 0) { //check the value of each key is undefined/NULL or not
              //  console.log("getValues ,,,,",x[kkk],x[kkk].includes("All"))

              if (!x[kkk].includes('All')) { // check the value of the key doesn't contains All as a value
                // console.log("getValues,,,,", item[kkk], x[kkk])
                if (item[kkk] === undefined || !x[kkk].includes(item[kkk])) {

                  return false;
                }
              }
            }
            //  console.log("not entered if")
          }
          return true;
        });

        var whereClause = '1==1 '
        for (let kkk in x) {
          // console.log("kkk x ",kkk, x,x[kkk],whereClause + ' && ! x[kkk]'+ '.includes("item["' + kkk + '"]) ')
          if (x[kkk] && x[kkk].length > 0 && x[key1] && x[key1].length > 0) { //check the value of each key is undefined/NULL or not
            if (kkk == key1) { // check if it is for the passed key then make it as not in
              whereClause = whereClause + ' && !x["' + kkk + '"]' + '.includes(item["' + kkk + '"]) '
            } else { //if not append and clause
              whereClause = whereClause + ' && x["' + kkk + '"]' + '.includes(item["' + kkk + '"])'
            }

          } else if (x[key1] && x[key1].length <= 0) {
            whereClause = whereClause + " && 1==2 "
          }
        }
        var example1 = _.clone(this.example)

        var invertFilteredData = example1.filter((item) => {

          if (eval(whereClause) && item) {
            return true;
          } else {
            return false
          }

        })
        var firstArray = _.uniq(filteredData.map(kv => kv[key1]))
        var secondArray = []
        if (x[key1] && x[key1].length > 0) {
          secondArray = _.uniq(invertFilteredData.map(kv => kv[key1]))
        }

        var unionArray = _.union(firstArray, secondArray)
        console.log("where clause", whereClause, x, key1, secondArray, invertFilteredData)
        return unionArray.sort(); //gets the unique values from the filteredData by mapping the passed key and sort the values in ascending order

//        console.log("where clause", x,key1)
      }

    }
  },
  methods: {
    showTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.show(); // Use the show method provided by Bootstrap-Vue
      }
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.hide(); // Use the hide method provided by Bootstrap-Vue
      }
    },
    rowLoopKey(rowd, index) {
      return rowd.syspk != null && rowd.syspk !== '' ? String(rowd.syspk) : 'r-' + index
    },
    formatDuplicateKeyError(errorData) {
      if (!errorData) {
        return 'A similar record already exists. Please review unique fields and try again.'
      }
      const cols = Array.isArray(errorData.columns) ? errorData.columns.filter(Boolean) : []
      const duplicateValue = errorData.duplicateValue != null ? String(errorData.duplicateValue) : ''
      if (cols.length === 0) {
        return errorData.message || 'A duplicate record already exists.'
      }
      const columnsText = cols.join(', ')
      if (duplicateValue) {
        return `A record with the same value for ${columnsText} already exists (${duplicateValue}).`
      }
      return `A record with the same value for ${columnsText} already exists.`
    },
    extractApiErrorMessage(err, fallbackMessage) {
      if (!err) {
        return fallbackMessage
      }
      if (err.code === 'ECONNABORTED') {
        return 'The request timed out. Please try again.'
      }
      if (!err.response) {
        return 'Unable to reach the server. Please check your internet connection and try again.'
      }
      const errorData = err.response.data || {}
      if (errorData.errorType === 'DUPLICATE_KEY') {
        return this.formatDuplicateKeyError(errorData)
      }
      if (typeof errorData.message === 'string' && errorData.message.trim()) {
        return errorData.message.trim()
      }
      if (typeof errorData.error === 'string' && errorData.error.trim()) {
        return errorData.error.trim()
      }
      if (Array.isArray(errorData.errors) && errorData.errors.length > 0) {
        const firstError = errorData.errors.find(e => typeof e === 'string' && e.trim())
        if (firstError) {
          return firstError.trim()
        }
      }
      if (typeof err.message === 'string' && err.message.trim()) {
        return err.message.trim()
      }
      return fallbackMessage
    },
    showApiError(err, fallbackMessage, useModalForDuplicate = false) {
      const errorData = err && err.response ? err.response.data : null
      const isDuplicateKeyError = !!(errorData && errorData.errorType === 'DUPLICATE_KEY')
      const errorMessage = this.extractApiErrorMessage(err, fallbackMessage)
      if (useModalForDuplicate && isDuplicateKeyError) {
        this.title = errorMessage
        this.showErrorModal = true
        return
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 6000,
        toaster: 'b-toaster-top-center'
      })
    },
    /** Sync sticky `left` with real column widths (nowrap columns exceed min-width). */
    scheduleStickyColumnMeasure() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.measureStickyColumnWidths(2)
        })
      })
    },
    /**
     * Edit/Add actions can change column widths one frame later (inputs/selects mount async).
     * Run immediate + delayed passes so sticky offsets stay aligned without manual reflow.
     */
    scheduleStickyColumnMeasureBurst() {
      this.scheduleStickyColumnMeasure()
      if (this._stickyMeasureTimer) {
        clearTimeout(this._stickyMeasureTimer)
      }
      this._stickyMeasureTimer = setTimeout(() => {
        this.scheduleStickyColumnMeasure()
      }, 70)
    },
    measureStickyColumnWidths(passesRemaining) {
      const table = this.$refs.mdmFormReportTable
      if (!table || !Array.isArray(this.columns) || this.columns.length === 0) {
        return
      }
      const snoIdx = this.snoColumnIndex
      if (snoIdx < 0 || !this.isFollowStickyColumn(snoIdx + 1)) {
        if (this.measuredStickyWidths.snoPx !== 0 || this.measuredStickyWidths.follow0Px !== 0) {
          this.measuredStickyWidths = {snoPx: 0, follow0Px: 0}
        }
        return
      }
      const ths = table.querySelectorAll('thead tr th')
      if (ths.length < this.columns.length + 1) {
        return
      }
      const snoTh = ths[snoIdx + 1]
      const followTh = ths[snoIdx + 2]
      if (!snoTh) {
        return
      }
      const snoPx = Math.max(Math.ceil(snoTh.getBoundingClientRect().width), 1)
      let follow0Px = 0
      if (followTh) {
        follow0Px = Math.max(Math.ceil(followTh.getBoundingClientRect().width), 1)
      }
      this.measuredStickyWidths = {snoPx, follow0Px}
      if (passesRemaining > 1) {
        this.$nextTick(() => {
          requestAnimationFrame(() => this.measureStickyColumnWidths(passesRemaining - 1))
        })
      }
    },
    updateSnoColumnCh(filteredList) {
      const idx = this.snoColumnIndex
      if (idx < 0 || !Array.isArray(this.Rcolumns) || idx >= this.Rcolumns.length) {
        this.snoColumnCh = 7
        return
      }
      const key = this.Rcolumns[idx]
      let maxLen = 1
      if (key && Array.isArray(filteredList) && filteredList.length > 0) {
        for (let j = 0; j < filteredList.length; j++) {
          const v = filteredList[j][key]
          if (v != null && v !== '') {
            const len = String(v).length
            if (len > maxLen) {
              maxLen = len
            }
          }
        }
      }
      maxLen = Math.min(maxLen, 18)
      const label = String((this.columns && this.columns[idx]) ? this.columns[idx] : 'S.No')
      /* Header + sort control often needs more `ch` than data-only estimate; avoids follow sticky sliding into anchor col. */
      const headerCh = Math.max(label.length + 7, 7)
      this.snoColumnCh = Math.max(maxLen + 3, headerCh, 7)
    },
    clearReportSearch() {
      if (this.debouncedSyncFilterValue && this.debouncedSyncFilterValue.cancel) {
        this.debouncedSyncFilterValue.cancel()
      }
      this.filterSearchInput = ''
      this.filterValue = ''
    },
    /**
     * Filter bar: `Select Only` / `Select Only LOV` columns that also have `filterFlag === true`
     * (config may mark only a subset of listbox columns as report filters).
     * Options are distinct values from `rowsdata` only, cascaded by sibling selections.
     */
    buildDimFilterBarFromColumns(columns) {
      if (!Array.isArray(columns)) return []
      return columns
          .filter(col =>  col.filterFlag === true)
          .sort((a, b) =>
              (a.formFieldDisplayOrder == null ? 0 : a.formFieldDisplayOrder)
              - (b.formFieldDisplayOrder == null ? 0 : b.formFieldDisplayOrder)
          )
          .map(col => ({
            displayName: col.formFieldDisplay,
            key: col.formColumnName
          }))
    },
    /** Cascading dimensions (region → branch → city); uses shared listbox SQL + LOV rows. */
    isSelectOnlyCascadeField(info) {
      return !!(info && info.inputFieldType === 'Select Only')
    },
    /** Flat list-of-values from listbox SQL; no cascade with other columns. */
    isSelectOnlyLovField(info) {
      if (!info || !info.inputFieldType) return false
      const t = info.inputFieldType
      return t === 'Select Only LOV' || t === 'Select Only Love'
    },
    isMdmListboxField(info) {
      return this.isSelectOnlyCascadeField(info) || this.isSelectOnlyLovField(info)
    },
    getColumnInfoByKey(columnKey) {
      if (!columnKey || !Array.isArray(this.columnsInfo)) return null
      return this.columnsInfo.find(c => c.formColumnName === columnKey) || null
    },
    /** Grid `columns[i]` titles that anchor horizontal sticky stacking after Action. */
    mdmIsStickyAnchorDisplayName(col) {
      if (col == null) return false
      return MDM_STICKY_ANCHOR_DISPLAY_SET.has(String(col))
    },
    isFollowStickyColumn(columnIndex) {
      if (columnIndex == null || columnIndex < 0) return false
      if (this.snoColumnIndex < 0) return false
      const afterSnoPos = columnIndex - this.snoColumnIndex
      return afterSnoPos > 0 && afterSnoPos <= 2
    },
    stickyFollowColumnStyle(columnIndex) {
      void this.measuredStickyWidths.snoPx
      void this.measuredStickyWidths.follow0Px
      if (!this.isFollowStickyColumn(columnIndex)) return {}
      const afterSnoPos = columnIndex - this.snoColumnIndex
      const zeroBasedFollowIndex = afterSnoPos - 1
      /* Measured --mdm-sticky-follow-0-px: first follow col is often wider than 150px (nowrap); second sticky must stack after its real width. */
      const edge = '0px'
      if (zeroBasedFollowIndex === 0) {
        return {
          left: `calc(var(--mdm-action-col-width) + var(--mdm-sno-col-width) + ${edge})`,
        }
      }
      return {
        left: `calc(var(--mdm-action-col-width) + var(--mdm-sno-col-width) + ${edge} + var(--mdm-sticky-follow-0-px))`,
      }
    },
    /** Natural sort that handles mixed numeric/string values. */
    naturalSort(values) {
      return values.slice().sort((a, b) =>
          String(a).localeCompare(String(b), undefined, {numeric: true, sensitivity: 'base'})
      )
    },
    /** Distinct, non-empty column values from a list of rows (preserving input order). */
    distinctColumnValues(rows, columnKey) {
      if (!Array.isArray(rows)) return []
      const seen = new Set()
      const out = []
      for (const item of rows) {
        if (!item) continue
        const v = item[columnKey]
        if (v == null || v === '') continue
        if (!seen.has(v)) {
          seen.add(v)
          out.push(v)
        }
      }
      return out
    },
    /** Full listbox universe for a column (empty array if none was loaded). */
    getListboxValues(columnKey) {
      const values = this.listboxData ? this.listboxData[columnKey] : null
      if (!Array.isArray(values)) return []
      return values.filter(v => v != null && v !== '')
    },
    /**
     * `Select Only` fields that share the same `fieldSelectListboxSql` (cascade order by display order).
     * `Select Only LOV` / `Select Only Love` are excluded from cascade groups.
     */
    computeLovSqlCascadeGroups() {
      if (!Array.isArray(this.columnsInfo)) return []
      const bySql = new Map()
      for (const col of this.columnsInfo) {
        if (col.inputFieldType !== 'Select Only' || !col.fieldSelectListboxSql) continue
        const sql = col.fieldSelectListboxSql
        if (!bySql.has(sql)) bySql.set(sql, [])
        bySql.get(sql).push(col)
      }
      const out = []
      for (const [sqlId, cols] of bySql) {
        if (cols.length < 2) continue
        cols.sort(
            (a, b) => (a.formFieldDisplayOrder == null ? 0 : a.formFieldDisplayOrder)
                - (b.formFieldDisplayOrder == null ? 0 : b.formFieldDisplayOrder)
        )
        out.push({sqlId, keys: cols.map(c => c.formColumnName)})
      }
      return out
    },
    findLovCascadeGroup(columnKey) {
      if (!this.lovSqlCascadeGroups || !this.lovSqlCascadeGroups.length) return null
      return this.lovSqlCascadeGroups.find(g => g.keys.includes(columnKey)) || null
    },
    getLovCascadeOptionsIfGrouped(activeKey, getSelected, alreadyChosen) {
      const g = this.findLovCascadeGroup(activeKey)
      if (!g) return null
      const rows = g.sqlId != null ? this.listboxLovRows[g.sqlId] : null
      const chosen = Array.isArray(alreadyChosen)
          ? alreadyChosen
          : (alreadyChosen != null && alreadyChosen !== '' ? [alreadyChosen] : [])

      if (!Array.isArray(rows) || rows.length === 0) {
        return this.naturalSort(
            Array.from(new Set([...chosen, ...this.getListboxValues(activeKey)]))
        )
      }
      let filtered = rows
      // Bidirectional cascade: constrain by all other selected keys in the same group.
      for (let i = 0; i < g.keys.length; i++) {
        const k = g.keys[i]
        if (k === activeKey) continue
        const selected = getSelected(k)
        if (Array.isArray(selected) && selected.length > 0) {
          filtered = filtered.filter(r => r && selected.includes(r[k]))
        } else if (!Array.isArray(selected) && selected !== undefined && selected !== null && selected !== '') {
          filtered = filtered.filter(r => r && r[k] === selected)
        }
      }
      const base = this.distinctColumnValues(filtered, activeKey)
      return this.naturalSort(Array.from(new Set([...chosen, ...base])))
    },
    /**
     * Rows that satisfy every active selection EXCEPT the one we're computing options for.
     * `getSelected(filterKey)` abstracts whether the selection is an array (filter bar)
     * or a single value (row edit/insert).
     */
    cascadeRowsExcludingWithKeys(activeKey, getSelected, cascadeKeys) {
      if (!Array.isArray(this.rowsdata) || this.rowsdata.length === 0) return []
      if (!Array.isArray(cascadeKeys) || !cascadeKeys.length) return this.rowsdata
      return this.rowsdata.filter(item => {
        return cascadeKeys.every(key => {
          if (key === activeKey) return true
          const selected = getSelected(key)
          if (selected === undefined || selected === null || selected === '') return true
          if (Array.isArray(selected)) {
            if (selected.length === 0) return true
            return selected.includes(item[key])
          }
          return item[key] === selected
        })
      })
    },
    cascadeRowsExcluding(activeKey, getSelected) {
      return this.cascadeRowsExcludingWithKeys(activeKey, getSelected, this.getSelectOnlyCascadeKeys())
    },
    /** Filter bar cascade keys: same subset as `dimSelectDpValues` (`filterFlag` ∩ listbox types). */
    getDimensionFilterCascadeKeys() {
      if (!Array.isArray(this.columnsInfo) || this.columnsInfo.length === 0) return []
      return this.columnsInfo
          .filter(info => this.isMdmListboxField(info) && info.filterFlag === true)
          .sort((a, b) =>
              (a.formFieldDisplayOrder == null ? 0 : a.formFieldDisplayOrder)
              - (b.formFieldDisplayOrder == null ? 0 : b.formFieldDisplayOrder)
          )
          .map(info => info.formColumnName)
          .filter(Boolean)
    },
    cascadeDimensionFilterRowsExcluding(activeKey, getSelected) {
      return this.cascadeRowsExcludingWithKeys(activeKey, getSelected, this.getDimensionFilterCascadeKeys())
    },
    /** True if any cascade key OTHER THAN `activeKey` has a selection via `getSelected`. */
    hasOtherCascadeSelection(activeKey, getSelected) {
      return this.getSelectOnlyCascadeKeys().some(key => {
        if (key === activeKey) return false
        const sel = getSelected(key)
        if (Array.isArray(sel)) return sel.length > 0
        return sel !== undefined && sel !== null && sel !== ''
      })
    },
    /**
     * Build option list for a cascade-aware select.
     *  - If another cascade key is actively restricting, return ONLY cascade-filtered rowsdata
     *    values (strict cascade). Already-chosen values are always preserved so selection
     *    isn't silently dropped.
     *  - If nothing else is restricting, return the full universe: rowsdata distinct values
     *    UNION the listbox universe (fixes low-cardinality lookups that don't appear in
     *    the currently loaded rows, e.g. ProductCategory / Active Flag / Is Deleted).
     *  - `Select Only LOV` / `Select Only Love`: always the full LOV list (no row/cascade mixing).
     *  - `Select Only` with shared listbox SQL: options from LOV rows in cascade order.
     */
    buildCascadeOptions(activeKey, getSelected, alreadyChosen) {
      const col = this.getColumnInfoByKey(activeKey)
      const chosen = Array.isArray(alreadyChosen)
          ? alreadyChosen
          : (alreadyChosen != null && alreadyChosen !== '' ? [alreadyChosen] : [])

      if (col && this.isSelectOnlyLovField(col)) {
        return this.naturalSort(
            Array.from(new Set([...chosen, ...this.getListboxValues(activeKey)]))
        )
      }

      const fromLovGroup = this.getLovCascadeOptionsIfGrouped(activeKey, getSelected, alreadyChosen)
      if (fromLovGroup !== null) {
        return fromLovGroup
      }

      const cascadeRows = this.cascadeRowsExcluding(activeKey, getSelected)
      const cascadeValues = this.distinctColumnValues(cascadeRows, activeKey)

      const otherActive = this.hasOtherCascadeSelection(activeKey, getSelected)
      const base = otherActive
          ? cascadeValues
          : [...cascadeValues, ...this.getListboxValues(activeKey)]

      return this.naturalSort(Array.from(new Set([...chosen, ...base])))
    },
    /** Filter-bar options come only from current report data (`rowsdata`), not listbox data. */
    buildFilterOptionsFromRows(activeKey) {
      const selected = this.selectVal[activeKey]
      const chosen = Array.isArray(selected)
          ? selected
          : (selected != null && selected !== '' ? [selected] : [])
      const baseRows = this.cascadeDimensionFilterRowsExcluding(activeKey, key => this.selectVal[key])
      const baseValues = this.distinctColumnValues(baseRows, activeKey)
      return this.naturalSort(Array.from(new Set([...chosen, ...baseValues])))
    },
    getRowsForFilterOptions(activeKey) {
      return this.cascadeDimensionFilterRowsExcluding(activeKey, key => this.selectVal[key])
    },
    getOptionsForFilter(activeKey) {
      return this.buildFilterOptionsFromRows(activeKey)
    },
    onFilterSelectionChange(changedKey) {
      const cascadeFilterKeys = this.dimSelectDpValues.map(filter => filter.key)
      if (!cascadeFilterKeys.includes(changedKey)) {
        return
      }
      cascadeFilterKeys.forEach(key => {
        if (key === changedKey) return

        const allowedValues = this.getOptionsForFilter(key)
        const currentValues = Array.isArray(this.selectVal[key]) ? this.selectVal[key] : []
        const prunedValues = currentValues.filter(value => allowedValues.includes(value))

        if (prunedValues.length !== currentValues.length) {
          this.$set(this.selectVal, key, prunedValues)
        }
      })
    },
    clearAllFilters() {
      this.dimSelectDpValues.forEach(filter => {
        this.$set(this.selectVal, filter.key, [])
      })
    },
    isMdmInlineSelectColumn(col, index) {
      if (col === 'Mfg. Name' || col === 'Brand Name') return false
      const info = this.columnsInfo[index]
      return this.isMdmListboxField(info)
    },
    isDimensionCascadeKey(columnKey) {
      return this.getSelectOnlyCascadeKeys().includes(columnKey)
    },
    /** Row edit/insert: cascade keys strictly `Select Only` (unchanged vs filter bar). */
    getSelectOnlyCascadeKeys() {
      if (!Array.isArray(this.columnsInfo) || this.columnsInfo.length === 0) return []
      return this.columnsInfo
          .filter(info => this.isSelectOnlyCascadeField(info))
          .map(info => info.formColumnName)
          .filter(Boolean)
    },
    getRowsForRowSelectOptions(rowModel, activeKey) {
      return this.cascadeRowsExcluding(activeKey, key => rowModel[key])
    },
    clearRowSelectOptionsCache() {
      this._rowSelectOptionsCache = Object.create(null)
    },
    /** Dependency signature so typing in unrelated text fields does not rebuild LOV option lists. */
    rowSelectOptionsDepsSignature(rowModel, activeKey) {
      const parts = [activeKey]
      let body
      const cinfo = this.getColumnInfoByKey(activeKey)
      if (cinfo && this.isSelectOnlyLovField(cinfo)) {
        parts.push('lov', rowModel[activeKey] == null ? '' : String(rowModel[activeKey]))
        body = parts.join('\x01')
      } else {
        const lovG = this.findLovCascadeGroup(activeKey)
        if (lovG) {
          parts.push('lovc')
          for (let j = 0; j < lovG.keys.length; j++) {
            const k = lovG.keys[j]
            parts.push(k, rowModel[k] == null ? '' : String(rowModel[k]))
          }
          body = parts.join('\x01')
        } else if (!this.isDimensionCascadeKey(activeKey)) {
          parts.push('static')
          body = parts.join('\x01')
        } else {
          parts.push('dim')
          const cascadeKeys = this.getSelectOnlyCascadeKeys()
          for (let j = 0; j < cascadeKeys.length; j++) {
            const k = cascadeKeys[j]
            parts.push(k, rowModel[k] == null ? '' : String(rowModel[k]))
          }
          body = parts.join('\x01')
        }
      }
      const n = Array.isArray(this.rowsdata) ? this.rowsdata.length : 0
      return `${body}\x01n\x01${n}`
    },
    computeOptionsForRowSelect(rowModel, activeKey) {
      const cinfo = this.getColumnInfoByKey(activeKey)
      if (cinfo && this.isSelectOnlyLovField(cinfo)) {
        const v = rowModel[activeKey]
        return this.naturalSort(
            Array.from(new Set([
              ...(v !== undefined && v !== null && v !== '' ? [v] : []),
              ...this.getListboxValues(activeKey)
            ]))
        )
      }
      if (this.findLovCascadeGroup(activeKey)) {
        return this.buildCascadeOptions(
            activeKey,
            key => rowModel[key],
            rowModel[activeKey]
        )
      }
      if (!this.isDimensionCascadeKey(activeKey)) {
        return this.getListboxValues(activeKey).slice()
      }
      return this.buildCascadeOptions(
          activeKey,
          key => rowModel[key],
          rowModel[activeKey]
      )
    },
    getOptionsForRowSelect(rowModel, activeKey) {
      if (!this._rowSelectOptionsCache) {
        this._rowSelectOptionsCache = Object.create(null)
      }
      const sig = this.rowSelectOptionsDepsSignature(rowModel, activeKey)
      const hit = this._rowSelectOptionsCache[activeKey]
      if (hit && hit.sig === sig) {
        return hit.options
      }
      const options = this.computeOptionsForRowSelect(rowModel, activeKey)
      this._rowSelectOptionsCache[activeKey] = {sig, options}
      return options
    },
    onRowDimensionSelectChange(rowModel, changedKey) {
      const chInfo = this.getColumnInfoByKey(changedKey)
      if (chInfo && this.isSelectOnlyLovField(chInfo)) {
        return
      }
      const lovG = this.findLovCascadeGroup(changedKey)
      if (lovG) {
        for (let j = 0; j < lovG.keys.length; j++) {
          const key = lovG.keys[j]
          if (key === changedKey) continue
          const allowed = this.getOptionsForRowSelect(rowModel, key)
          const current = rowModel[key]
          if (current !== undefined && current !== null && current !== '' && !allowed.includes(current)) {
            this.$set(rowModel, key, '')
          }
        }
        return
      }
      if (!this.isDimensionCascadeKey(changedKey)) return
      this.getSelectOnlyCascadeKeys().forEach(key => {
        if (key === changedKey) return
        const allowed = this.getOptionsForRowSelect(rowModel, key)
        const current = rowModel[key]
        if (current !== undefined && current !== null && current !== '' && !allowed.includes(current)) {
          this.$set(rowModel, key, '')
        }
      })
    },
    onRowSelectInput(rowModel, columnKey, value) {
      this.$set(rowModel, columnKey, value)
      this.onRowDimensionSelectChange(rowModel, columnKey)
    },
    fieldIsMandatory(columnsInfoRow) {
      return columnsInfoRow && columnsInfoRow.fieldIsNullable === 'N'
    },
    veeRulesEmail(columnsInfoRow) {
      return this.fieldIsMandatory(columnsInfoRow) ? 'required|email' : 'email'
    },
    veeRulesNumeric(columnsInfoRow) {
      return this.fieldIsMandatory(columnsInfoRow) ? 'required|numeric' : 'numeric'
    },
    veeRulesPhone(columnsInfoRow) {
      return this.fieldIsMandatory(columnsInfoRow) ? 'required|indianPhone' : 'indianPhone'
    },
    transformValue(value, caseType) {
      if (!value) return value;

      switch(caseType) {
        case 'UpperCase':
          return _.toUpper(value);
        case 'LowerCase':
          return _.toLower(value);
        case 'ProperCase': {
          // _.startCase treats letter+digit transitions as word breaks (e.g. "E123" -> "E 123"),
          // which corrupts contiguous alphanumeric IDs. Use a single-word title case instead.
          const str = _.isString(value) ? value : String(value)
          if (/^[A-Za-z0-9]*$/.test(str)) {
            return str.length === 0 ? str : _.upperFirst(_.toLower(str))
          }
          return _.startCase(_.toLower(str))
        }
        case 'SentenceCase':
          return _.upperFirst(_.toLower(value));
        default:
          return value;
      }
    },
    getInsertColumnKey(index) {
      if (Array.isArray(this.Rcolumns) && index >= 0 && index < this.Rcolumns.length) {
        return this.Rcolumns[index]
      }
      const info = Array.isArray(this.columnsInfo) ? this.columnsInfo[index] : null
      return info && info.formColumnName ? info.formColumnName : null
    },
    buildDefaultInsertRow() {
      const row = {}
      this.columnsInfo.forEach((colInfo, index) => {
        const key = this.getInsertColumnKey(index)
        if (!key || key === 'syspk') {
          return
        }
        const defaultValue = colInfo && Object.prototype.hasOwnProperty.call(colInfo, 'defaultValue')
          ? colInfo.defaultValue
          : null
        row[key] = (defaultValue === undefined || defaultValue === null) ? '' : defaultValue
      })
      this.coerceNumberFieldsInRow(row)
      return row
    },
    updateInsertValue(event,column,caseType){
      let value = event.target.value;

      // transform based on requiredCase
      value = this.transformValue(value, caseType);

      this.$set(this.rowEdit, column, value);
    },

    updateValue(event, column, caseType) {
      let value = event.target.value;

      // transform based on requiredCase
      value = this.transformValue(value, caseType);

      this.$set(this.rowInsert, column, value);
    },
    autoExpand(e) {
      e.target.style.height = 'auto';
      e.target.style.height = (e.target.scrollHeight) + 'px';
    },
    sortBy: function (key) {
      console.log("The sort Key is ", key)
      if (key !== this.sortKey) {
        this.sortKey = key;
        this.sortOrder = 'asc';
        return
      }
      if (this.sortOrder === 'asc') {
        this.sortOrder = 'desc'
        return
      }
      if (this.sortOrder === 'desc') {
        this.sortKey = ''
        this.sortOrder = ''
        return
      }
      this.sortOrder = 'asc'
    },
    date(event, fieldName) {
      let val = event.target.value.this.rowEdit[fieldName] = val;
    },
    handleValidateFunc(fncName, value) {
      console.log("Handle function called with func name", fncName, value);
      if (fncName) {
        this[fncName](value)
      }
    },
    /** @param {Object} [rowTarget] When editing, pass `rowInsert`; omit for insert (`rowEdit`). */
    handleIndianPhoneNumberInput(event, fieldName, rowTarget) {
      let phone = event.target.value.replace(/\D/g, '');  // Remove non-digits

      // Ensure first digit is 6-9
      if (phone.length > 0 && !['6', '7', '8', '9'].includes(phone[0])) {
        phone = phone.substring(1);  // Remove invalid starting digit
      }

      phone = phone.substring(0, 10);  // Limit to 10 digits
      const target = rowTarget || this.rowEdit
      this.$set(target, fieldName, phone)
    },
    numberInputDisplay(val) {
      if (val === null || val === undefined || val === '') {
        return '';
      }
      return String(val);
    },
    /** Align server-loaded values with fieldValidationType === 'number' (same rules as handleNumberInput). */
    coerceNumberFieldsInRow(row) {
      if (!row) {
        return;
      }
      this.columns.forEach((col, index) => {
        if (this.columnsInfo[index]['fieldValidationType'] !== 'number') {
          return;
        }
        const key = this.Rcolumns[index];
        const v = row[key];
        if (v === null || v === undefined || v === '') {
          return;
        }
        if (typeof v === 'number') {
          return;
        }
        if (typeof v === 'string') {
          const raw = v.replace(/[^0-9]/g, '');
          const next = raw === '' ? '' : parseInt(raw, 10);
          this.$set(row, key, next);
        }
      });
    },
    handleNumberInput(event, fieldName, rowTarget) {
      const raw = event.target.value.replace(/[^0-9]/g, '');
      const value = raw === '' ? '' : parseInt(raw, 10);
      this.$set(rowTarget, fieldName, value);
    },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
    // sendEmail: function () {
    //   this.$loadScript("https://smtpjs.com/v3/smtp.js")
    //       .then(() => {
    //         window.Email.send({
    //           Host: "mail.compegence.com",
    //           Username: "muin.shariff@compegence.com",
    //           Password: "Mu!nYEs#%76@shineS",
    //           To: 'abdur.rahman@compegence.com,muin.shariff@compegence.com',
    //           From: "muin.shariff@compegence.com",
    //           Subject: "Request:MDM Approval",
    //           Body: "Please check the Approval window for a new record addition. Validate and Approve.",
    //         }).then(
    //             alert("mail sent successfully")
    //         )
    //       })
    // },

    // ValidateMFR: function (value) {
    //
    //   let txtmfrCode = document.getElementById("txtmfrCode");
    //   let lblmfrCode = document.getElementById("lblmfrCode")
    //   console.log("Entered validate MFR code", txtmfrCode.value)
    //   let regex = /([A-Z]){2}([0-9]){4}$/;
    //   if (regex.test(value.toUpperCase())) {
    //     lblmfrCode.style.visibility = "hidden";
    //     return true;
    //   } else {
    //     lblmfrCode.style.visibility = "visible";
    //     return false;
    //   }
    // },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.clearRowSelectOptionsCache()
        if ($this.debouncedSyncFilterValue && $this.debouncedSyncFilterValue.cancel) {
          $this.debouncedSyncFilterValue.cancel()
        }
        $this.filterSearchInput = ''
        $this.filterValue = ''
        $this.headerColumns = []
        $this.dimSelectDpValues = []
        $this.currentRepActionIconsData = []
        $this.apiData = null
        $this.icons = []
        $this.downloadSqlId = null
        $this.pendingDownloadFormat = 'xlsx'
        $this.downloadFormatChoice = 'xlsx'
        $this.downloadLoading = false
        $this.iconOnChangeFlag = []
        $this.showFSButton = true
        setTimeout(() => {
          if (from.matched.some(record => record.meta.requiresMdmConfig)) {
            $this.loadReportConfig()
          }
        }, 300)

      })
    },
    /**
     * Whether add (insert-after) and edit are allowed for this API row (`is_row_editable`).
     * If `is_row_editable` is missing on the row object, actions are allowed (legacy reports).
     */
    isMdmRowActionAllowed(rowd) {
      if (!rowd) {
        return false
      }
      if (!Object.prototype.hasOwnProperty.call(rowd, 'is_row_editable')) {
        return true
      }
      const v = rowd.is_row_editable
      return v === true || v === 'true' || v === 1
    },
    //Show Edit Input Field
    edit: function (syspk) {
      console.log('Entered into edit function', syspk);
      const rowToEdit = this.filteredItems.find(row => row.syspk === syspk)
      if (!this.isMdmRowActionAllowed(rowToEdit)) {
        this.$bvToast.toast('This row cannot be edited.', {
          title: 'Not allowed',
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000,
          toaster: 'b-toaster-top-center',
        })
        return
      }
      this.showInputfield = true;
      this.editableId = syspk;

      // Create a deep copy of the row (API/JSON fields are often strings)
      this.rowInsert = _.cloneDeep(rowToEdit);
      this.coerceNumberFieldsInRow(this.rowInsert);
      console.log("Processed row for editing:", this.rowInsert);
    },
    //Show Row
    showRow: function (syspk) {
      console.log('Entered into add function', syspk)
      const anchor = this.filteredItems.find(row => row.syspk === syspk)
      if (!this.isMdmRowActionAllowed(anchor)) {
        this.$bvToast.toast('You cannot add a record for this row.', {
          title: 'Not allowed',
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000,
          toaster: 'b-toaster-top-center',
        })
        return
      }
      this.rowEdit = this.buildDefaultInsertRow()
      this.showInput = true
      this.savetableId = syspk

    },
    //High Light Selected Row
    toggle(syspk) {
      /* const index = this.opened.indexOf(id)*/
      this.opened.push(syspk)
    },
    show: function () {
      this.$modal.show('hello-world')
    },
    hide: function () {
      this.$modal.hide('hello-world')
    },
    //Hide Add record or save record
    hideR: function (syspk) {
      if (this.savetableId == syspk) {
        this.savetableId = null
        this.editableId = null
      } else {
        this.savetableId = syspk
        this.editableId = syspk
      }
      this.showInputfield = false
      this.rowEdit = []
      this.rowInsert = []
    },
    /**
     * Map a provider `vid` (column key or legacy id) to the grid column label for toasts.
     */
    mdmResolveVeeVidToLabel(vid) {
      const key = vid == null ? '' : String(vid)
      if (!key) {
        return ''
      }
      if (Array.isArray(this.Rcolumns) && Array.isArray(this.columns)) {
        const idx = this.Rcolumns.indexOf(key)
        if (idx >= 0 && this.columns[idx] != null) {
          return String(this.columns[idx])
        }
      }
      return key.replace(/^mdm-(insert|edit)-(email|num|phone)-/, '')
    },
    /**
     * Turn VeeValidate observer `errors` map into a short human-readable line for toasts.
     */
    formatMdmVeeObserverErrors(errors) {
      if (!errors || typeof errors !== 'object') {
        return ''
      }
      const parts = []
      for (const [rawVid, msgs] of Object.entries(errors)) {
        const msg = Array.isArray(msgs) ? msgs.find((m) => m && String(m).trim()) : msgs
        if (msg == null || (typeof msg === 'string' && !msg.trim())) {
          continue
        }
        const label = this.mdmResolveVeeVidToLabel(rawVid) || String(rawVid)
        parts.push(`${label}: ${typeof msg === 'string' ? msg : String(msg)}`)
      }
      return parts.join('; ')
    },
    /**
     * Runs all VeeValidate providers under the MDM grid observer (inline insert/edit rows).
     * @returns {Promise<boolean>}
     */
    async mdmAssertInlineVeeValid() {
      const obs = this.$refs.mdmReportObserver
      if (!obs) {
        return true
      }
      /** @type {(opts?: object) => Promise<boolean>} */
      const validateFn = typeof obs.validate === 'function' ? obs.validate.bind(obs) : null
      const validateWithInfo = typeof obs.validateWithInfo === 'function'
        ? obs.validateWithInfo.bind(obs)
        : null
      if (!validateFn && !validateWithInfo) {
        return true
      }

      try {
        if (validateWithInfo) {
          const info = await validateWithInfo()
          const ok = !!(info && (info.isValid === true || info.valid === true))
          if (ok) {
            return true
          }
          const detail = this.formatMdmVeeObserverErrors(info && info.errors)
          const body = detail
            ? `Correct the following fields before continuing: ${detail}`
            : 'Fix the highlighted validation errors before saving or validating.'
          this.$bvToast.toast(body, {
            title: 'Validation error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 8000,
            toaster: 'b-toaster-top-center',
          })
          return false
        }

        const isValid = await validateFn()
        if (isValid === true) {
          return true
        }
        this.$bvToast.toast(
            'Fix the highlighted validation errors before saving or validating.',
            {
              title: 'Validation error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5500,
              toaster: 'b-toaster-top-center',
            },
        )
        return false
      } catch (e) {
        console.warn('mdmAssertInlineVeeValid: observer threw', e)
        return true
      }
    },
    validateEditRow: async function (row) {
      if (!(await this.mdmAssertInlineVeeValid())) {
        return
      }
      this.rowd = row
      console.log("Entered validate Edit function", row)
      let hasEmptyMandatoryFields = false;
      const mandatoryFields = [];

      this.columns.forEach((col, index) => {
        const columnKey = this.Rcolumns[index];
        const v = row[columnKey];
        const isEmpty = v === undefined || v === null || v === '';
        if (this.columnsInfo[index]['fieldIsNullable'] === 'N' && isEmpty && !this.mdmIsStickyAnchorDisplayName(col)) {
          hasEmptyMandatoryFields = true;
          mandatoryFields.push(col);
        }
      });

      if (hasEmptyMandatoryFields) {
        // Show error message instead of modal
        this.$bvToast.toast(`Please fill all mandatory fields: ${mandatoryFields.join(', ')}`, {
          title: 'Validation Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-center'
        });
        return;
      }
      this.$refs["validate-update-row-box"].show();
    },
    validateInsertRow: async function (row) {
      const anchor = this.rowsdata.find(r => r.syspk === this.savetableId)
      if (!this.isMdmRowActionAllowed(anchor)) {
        this.$bvToast.toast('Insert is not allowed for this row.', {
          title: 'Not allowed',
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000,
          toaster: 'b-toaster-top-center',
        })
        return
      }
      if (!(await this.mdmAssertInlineVeeValid())) {
        return
      }
      // Check for mandatory fields
      let hasEmptyMandatoryFields = false;
      const mandatoryFields = [];

      this.columns.forEach((col, index) => {
        const columnKey = this.Rcolumns[index];
        const v = row[columnKey];
        const isEmpty = v === undefined || v === null || v === '';
        if (this.columnsInfo[index]['fieldIsNullable'] === 'N' && isEmpty && !this.mdmIsStickyAnchorDisplayName(col)) {
          hasEmptyMandatoryFields = true;
          mandatoryFields.push(col);
        }
      });

      if (hasEmptyMandatoryFields) {
        // Show error message instead of modal
        this.$bvToast.toast(`Please fill all mandatory fields: ${mandatoryFields.join(', ')}`, {
          title: 'Validation Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-center'
        });
        return;
      }

      // Create an object with all column keys and their values
      const rowData = {};

      // Loop through all columns and collect available values
      this.columns.forEach((col, index) => {
        const columnKey = this.Rcolumns[index];
        console.log("columnKey", columnKey);
        // Skip if column is 'syspk'
        if (columnKey !== 'syspk') {
          // Always include the key, use null for missing values
          rowData[columnKey] = row[columnKey] !== undefined ? row[columnKey] : '';
        }
      });

// Store the filtered data
      this.rowdIns = rowData;

      console.log("Filtered row data with key-value pairs:", rowData);
      console.log("Entered validate insert function", row.c_name);

      // Show the validation modal only if all mandatory fields are filled
      this.$refs["validate-insert-row-box"].show();

      // If you need to return the data for further processing
      return rowData;
    },
    updateRecord: function () {
      let updObj = Object.assign({}, this.rowInsert)
      console.log("check the type of update Record", updObj, this.rowInsert)
      axios.post('/api/mdm-form-update/' + this.$route.params.submenuId, updObj, {
        skipGlobalDataErrorModal: true,
        headers: {
          'info-params': JSON.stringify({
            menuId: this.$route.params.menuId,
            submenuId: this.$route.params.submenuId
          }),
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log("Entered mdm-form-update API", res)
        this.loadReportConfig()
        this.formMessage = "Record Updated Successfully"
        this.$refs["success-box"].show();
        this.showInputfield = false
        this.editableId = null
        this.savetableId = null
        this.rowInsert = [];
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      })
          .catch(err => {
            console.log("Error in mdm-form-inser API", err)
            this.showApiError(err, 'Unable to update the record. Please try again.')
          })

      console.log("Entered validate update function", this.rowInsert)

    },
    insertRecord: function () {
      const anchor = this.rowsdata.find(r => r.syspk === this.savetableId)
      if (!this.isMdmRowActionAllowed(anchor)) {
        this.$bvToast.toast('Insert is not allowed for this row.', {
          title: 'Not allowed',
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000,
          toaster: 'b-toaster-top-center',
        })
        return
      }
      this.columns.forEach((col, index) => {
        if (this.columnsInfo[index]['fieldValidationType'] === 'date') {
          const fieldName = this.Rcolumns[index];

          // Convert date string to Date object if it exists
          if (this.rowdIns[fieldName]) {
            // Assuming date is stored in DD/MM/YYYY format
            const dateParts = this.rowdIns[fieldName].split('/');
            if (dateParts.length === 3) {
              const day = parseInt(dateParts[0], 10);
              const month = parseInt(dateParts[1], 10) - 1; // months are 0-indexed
              const year = parseInt(dateParts[2], 10);

              // Create date without time portion (sets to local midnight)
              const dateObj = new Date(year, month, day);
              this.rowInsert[fieldName] = dateObj;

              console.log("Formatted date:", this.rowInsert[fieldName]);
              // }
            }
          }
        }
      });
      let insObj = Object.assign({}, this.rowdIns)
      console.log("Entered validate insert function", insObj)
      axios.post('/api/mdm-form-insert/' + this.$route.params.submenuId, insObj, {
        skipGlobalDataErrorModal: true,
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }
      ).then(res => {
        console.log("Entered mdm-form-insert API", res)
        // Find email field and its value
        let recipientEmail = null;
        this.columns.forEach((col, index) => {
          if (this.columnsInfo[index]['fieldValidationType'] === 'email') {
            const fieldName = this.Rcolumns[index];
            if (this.rowdIns[fieldName]) {
              recipientEmail = this.rowdIns[fieldName];
            }
          }
        });

        // Only send email if we found an email field with a value
        if (recipientEmail) {
          console.log("send email api called")
   /*       const data={
            email:recipientEmail,
            purpose:"mdm-report"
          }
          axios.post('/api/send-mail',data,{
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }).then(resp=>{
                if(resp.status===200){
                  // Success toast
                  this.$bvToast.toast('Email sent successfully!', {
                    title: 'Success',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 5000,
                    toaster: 'b-toaster-top-center'
                  });
                }
              }
          ).catch(error => {
            console.log("Error in sending email", error)
            // Error toast
            const errorMessage = error.response?.data?.error || 'Failed to send email';
            this.$bvToast.toast(errorMessage, {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-center'
            });

            console.error('Email sending error:', error);
          })*/
        }

        this.savetableId = null;
        this.showInputfield = false;
        this.showInput = false;
        this.formMessage = "Record Added Successfully"
        this.$refs["success-box"].show();
        this.rowEdit = [];
        // this.loadReportConfig()
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      })
          .catch(err => {
            console.log("Error in mdm-form-insert API", err)
            this.showApiError(err, 'Unable to add the record. Please review your data and try again.', true)
            // Log the full error for debugging
            console.error('Full error details:', err);
          })
      // console.log("Entered validate insert function", this.rowdIns)

    },
    // fetchListbox: function (sql) {
    //   var listboxData = []
    //   axios.post('/api/fetchDataWithParam/' + sql + '/Any', {}).then(
    //       res => {
    //         listboxData = res.data.rowsdata


    //       },
    //       err => {
    //         console.log('Error Fetching data', err)
    //       }
    //   )
    //   console.log("response of listbox SQL", listboxData)
    //   return listboxData;

    // },
    GSTINValidate: function (gstinNum) {
      let url = 'https://sheet.gstincheck.co.in/check/' + '0739c4914d38e88bcb6346fa805800b4' + '/' + gstinNum
      axios.get(url)
          .then(res => {
            this.result = res
            console.log("results", this.result)
            this.message = res.data.message
            this.name = res.data.data.tradeNam
          }, err => {
            console.log('Error in record', err)
          })
    },
    loadReportConfig: async function () {
      console.info('loading summary', this.$route.params.submenuId)
      let menuParam = this.$route.params.submenuId
      this.$store.dispatch("loadState").then(() => {

      let actionIconsData = this.$store.state.actionIcons
      //  let submenuParam = this.$route.params.submenuId
      this.listboxData = {}
      this.listboxLovRows = {}
      this.lovSqlCascadeGroups = []
      this.clearRowSelectOptionsCache()


      //Get Request
      axios.get('/api/formConfigColumn/' + menuParam)
          //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
          .then(res => {
            this.apiData = res.data
            this.rowsdata = this.apiData.rowsData
            this.formTitle = this.apiData.columns[0].formName
            this.columnsInfo = this.apiData.columns
            this.icons = this.apiData.icons
            this.downloadSqlId = this.apiData.downloadDatasqlId != null
                ? this.apiData.downloadDatasqlId
                : null
            this.columns = this.apiData.columns.map(function (el) {
              return el.formFieldDisplay;
            })
            this.dimSelectDpValues = this.buildDimFilterBarFromColumns(this.apiData.columns)
            this.filters = this.dimSelectDpValues

            // action icons config
            let repIcons = this.icons
            var repActionIconsSyspkArray = repIcons[0]?.actionIconsSyspkArray ? repIcons[0].actionIconsSyspkArray : []
              console.log('Rep Action icons', repActionIconsSyspkArray, repIcons[0]?.actionIconsSyspkArray)
            this.currentRepActionIconsData = actionIconsData.filter(r => repActionIconsSyspkArray.includes(r.syspk))
            console.log('ReportConfigRes', this.apiData, this.apiData.columns)
            this.screenletTitleInfo = this.apiData.columns[0]?.screenletTitleInfo
            var rowsDataKeys = filterDisplayedDataKeys(Object.keys(this.rowsdata[0]))
            this.rowsDataDimKeys = rowsDataKeys
            this.selectVal = this.dimSelectDpValues.reduce((acc, filter) => {
              acc[filter.key] = []
              return acc
            }, {})
            console.log('Dimension variables Keys', this.rowsDataDimKeys)
            console.log('Data for Report', this.rowsdata)
            console.log('Dimension variables Keys', this.dimSelectDpValues)
            //console.log('Report Title',this.apiData.columns[0].repName)
            //console.log('Report headers',this.nameArray)
            const sorted = this.rowsdata.map(person => {
              let rtn = {}
              this.rowsDataDimKeys.forEach(key => {
                rtn[key] = person[key]
              })
              return rtn
            })
            this.example = [...new Set(sorted.map(JSON.stringify))].map(JSON.parse)
            //console.log("Distinct values of report data",sorted)

            this.lovSqlCascadeGroups = this.computeLovSqlCascadeGroups()
            const listboxFields = this.columnsInfo.filter(
                k => this.isMdmListboxField(k) && k.fieldSelectListboxSql
            )
            const byListboxSql = new Map()
            for (const s of listboxFields) {
              if (!byListboxSql.has(s.fieldSelectListboxSql)) {
                byListboxSql.set(s.fieldSelectListboxSql, [])
              }
              byListboxSql.get(s.fieldSelectListboxSql).push(s)
            }
            for (const [sql, cols] of byListboxSql) {
              console.log('listbox / LOV data (SQL)', sql, cols.map(c => c.formColumnName), cols.map(c => c.inputFieldType))
              axios.post('/api/fetchDataWithParam/' + sql + '/Any', {}).then(
                  res => {
                    const rows = res.data.rowsData || []
                    if (this.lovSqlCascadeGroups.some(g => g.sqlId === sql)) {
                      this.$set(this.listboxLovRows, sql, rows)
                    }
                    for (const s of cols) {
                      const values = rows
                          .map(item => item[s.formColumnName])
                          .filter(v => v != null && v !== '')
                      this.$set(this.listboxData, s.formColumnName, values)
                    }
                    if (sql === 'SQL731') {
                      this.mfgNameList = rows
                      console.log('Mfg names list', this.mfgNameList, this.mfgNameList.filter(f => f.c_mfac_code == 'MF0001'))
                    }
                    if (sql === 'SQL732') {
                      this.brandNameList = rows
                      console.log('brand names list', this.brandNameList)
                    }
                  }).catch(e => {
                    console.log('error', e)
                  })
            }
            console.log('LOV cascade groups (Select Only only)', this.lovSqlCascadeGroups)
            console.log('listbox / LOV fields', this.listboxData)
            this.scheduleStickyColumnMeasure()

          }, err => {
            console.log('Error Fetching data', err)
          })


      /*               //Get Request
                      axios.get('/api/reportConfigColumn/'+ menuParam +'/G01')
                      .then(res => {
                      this.drilldowndata = res.data
                      var columns = this.drilldowndata.columns
                      //var rowsdata = this.drilldowndata.rowsdata
                      console.log("API Response",this.drilldowndata)
                      var drilldownlevels = [...new Set(columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
                      var levelColumns = []
                      var headerColumns = []
                      for (var i=1; i<=drilldownlevels.length; i++)
                      {
                          var value ='level'+i
                          levelColumns[i] = columns.filter( ind => ind.drilldownLevel ==value)
                          headerColumns[i] = levelColumns[i].map(function (el) { return el.headerColumnDisplay;})
                      }
                      //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
                      console.log("Drilldown data level1",headerColumns[1])
                      console.log("Drilldown data level2",headerColumns[2])
                      console.log("Drilldown data level3",headerColumns[3])

                      }, err => {
                      console.log('Error Fetching data', err)
                      })

                     //Post Request
                     const params = new URLSearchParams();
                     params.append('param1', 'value1');
                     params.append('param2', 'value2');
                     axios.post('/api/testparams', params)
                     //axios.post('/api/reportConfigColumn/'+ menuParam +'/G01')
                     .then(res => {
                      this.string = res.data
                     //var columns = this.drilldowndata.columns
                     //var rowsdata = this.drilldowndata.rowsdata
                     console.log("Post API Called",this.string)
                     }, err => {
                         console.log('Error Fetching data', err)
                         })
                 }*/
      })
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      console.log("menuDetails", menuDetails);
      await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success",this.$store.state.deviceType)
    },
    handleRepActionIcon(fnName, index) {
      if (!fnName || typeof this[fnName] !== 'function') return
      const val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val)
      this[fnName](this.showFSButton)
    },
    downloadData() {
      if (this.downloadSqlId == null || this.downloadSqlId === '') {
        this.$bvToast.toast('Download is not configured for this form.', {
          title: 'Notice',
          variant: 'warning',
          autoHideDelay: 5000,
        })
        return
      }
      this.downloadFormatChoice = 'xlsx'
      this.$refs['download-format-modal'].show()
    },
    onDownloadFormatModalShown() {
      this.downloadFormatChoice = 'xlsx'
    },
    confirmDownloadFormatModal() {
      this.pendingDownloadFormat = this.downloadFormatChoice
      this.$refs['download-format-modal'].hide()
      this.$nextTick(() => {
        this.executeFetchCsvDownload()
      })
    },
    cancelDownloadFormatModal() {
      this.$refs['download-format-modal'].hide()
    },
    async executeFetchCsvDownload() {
      await runFetchCsvExport({
        downloadsqlId: this.downloadSqlId,
        datasqlId: null,
        reportTitle: this.formTitle,
        postBody: this.$store.state.lbWhereCond[this.$route.params.submenuId] || {},
        menuId: this.$route.params.menuId,
        submenuId: this.$route.params.submenuId,
        pendingDownloadFormat: this.pendingDownloadFormat,
        userId: this.$store.state.user.userId,
        onShowLoading: () => {
          this.$refs['download-modal'].show()
          this.downloadLoading = true
        },
        onHideLoading: () => {
          this.downloadLoading = false
          this.$refs['download-modal'].hide()
        },
        toastError: (msg, title = 'Error') => {
          this.$bvToast.toast(msg, {
            title,
            autoHideDelay: 5000,
            variant: 'danger',
          })
        },
        toastInfo: (body, title) => {
          this.$bvToast.toast(body, {
            title,
            autoHideDelay: 10000,
            variant: 'info',
          })
        },
        toastPollError: (msg) => {
          this.$bvToast.toast(msg, { variant: 'danger', autoHideDelay: 8000 })
        },
        onPollSuccess: () => {
          this.showErrorModal = true
          this.title =
            'Your download has finished! You can find the file in your download folder.'
        },
      })
    },
  }
}
</script>
<style scope>

.mdm-form-report-card {
  --mdm-header-bg: linear-gradient(180deg, #334155 0%, #1f2937 100%);
  --mdm-header-border: #0f172a;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  overflow: hidden;
  font-family: "Inter", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif;
}

.mdm-form-card-header {
  gap: 8px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}

.mdm-row-count-badge {
  font-weight: 600;
  font-size: 0.72rem;
  color: #334155 !important;
}

.mdm-search-addon {
  background: #fff;
  border-color: #cbd5e1;
  padding: 0.2rem 0.45rem;
}

.mdm-search-clear {
  border-color: #cbd5e1;
  line-height: 1;
  padding: 0.2rem 0.45rem;
}

.mdm-pagination-bar {
  gap: 12px;
}

.mdm-per-page-group {
  gap: 8px;
}

.mdm-per-page-select {
  min-width: 4.5rem;
}

.mdm-form-header-toolbar {
  min-width: 0;
}

.mdm-form-search {
  width: 100%;
  max-width: 280px;
}

@media (min-width: 768px) {
  .mdm-form-search {
    width: 220px;
  }
}

.mdm-form-header-icons {
  gap: 4px;
}

.mdm-form-action-icon-wrap {
  cursor: pointer;
  padding: 2px 4px;
}

.mdm-form-action-icon-wrap i {
  font-size: 15px;
}

.download-format-modal-body .download-format-meta {
  padding-left: 0.15rem;
  line-height: 1.45;
}

.download-format-radios .custom-control {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

th {
  font-size: 12px;
}

/*
.grid-container {
  overflow-y: auto;
  height: 500px;
}*/

td {
  text-align: left;
}

.error {
  color: Red;
  visibility: hidden;
}

/* Base cell styling */
.multi-line-cell {
  white-space: normal !important;
  word-wrap: break-word !important;
}

/* Default width (when not textarea) */
.multi-line-cell {
  max-width: 150px;
}

/* Wider width for textarea fields */
.multi-line-cell.textarea-cell {
  max-width: 500px;
}

.card-body {
  padding: 1px;
}

.custom-padding{
  padding: 4px 6px;
}

.mdm-report-card-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  min-width: 0;
  padding: 6px 8px !important;
  overflow-y: auto;
  max-height: 78vh;
}

.mdm-report-grid {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.report-table-wrapper {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  width: 100%;
}

.mdm-report-vee-observer {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.report-data-table {
  margin-bottom: 0;
  width: 100%;
  max-width: none;
  table-layout: auto;
  --mdm-action-col-width: 88px;
  font-family: "Inter", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif;
  font-size: 0.82rem;
}

.report-data-table col.mdm-col-action {
  width: var(--mdm-action-col-width);
  min-width: var(--mdm-action-col-width);
}

.report-data-table th,
.report-data-table td {
  vertical-align: middle;
  white-space: nowrap;
  font-size: 0.8rem;
  padding: 0.35rem 0.45rem;
}

.report-data-table thead th.sno-col,
.report-data-table tbody td.sno-col,
.report-data-table tbody th.mdm-form-cell.sno-col {
  text-align: center;
  white-space: nowrap;
  padding-left: 0.28rem;
  padding-right: 0.28rem;
  box-sizing: border-box;
  /* Lock to --mdm-sno-col-width from table so sticky follow `left` calc matches rendered column. */
  width: var(--mdm-sno-col-width, 7ch);
  min-width: var(--mdm-sno-col-width, 7ch);
}


.report-data-table tbody td.multi-line-cell {
  white-space: normal;
  word-wrap: break-word;
}

.report-data-table tbody tr:hover td {
  background-color: #f0f7ff;
}

.report-data-table tbody tr:nth-child(even) td {
  background-color: #fcfdff;
}

/* Global zebra when using one <tbody> per data row (multi-tbody pattern) */
.report-data-table tbody tr.mdm-data-row--alt td {
  background-color: #fcfdff;
}

.report-data-table .action-col {
  position: sticky;
  left: 0;
  width: var(--mdm-action-col-width);
  min-width: var(--mdm-action-col-width);
  max-width: var(--mdm-action-col-width);
  box-shadow: none;
}

/* Body action column: stay above scrolling cells; header corner stays on top when scrolling vertically */
.report-data-table tbody .action-col {
  z-index: 11;
  background: #fff;
}

/* Keep S.No visible while scrolling horizontally (after sticky Action col) */
.report-data-table thead th.sno-col,
.report-data-table tbody td.sno-col,
.report-data-table tbody th.mdm-form-cell.sno-col {
  position: sticky;
  left: var(--mdm-action-col-width);
}

.report-data-table thead th.sno-col {
  z-index: 16;
  /* background: var(--mdm-header-bg); */
  box-shadow: none;
}

.report-data-table tbody td.sno-col {
  z-index: 12;
  background: #fff;
  box-shadow: none;
}

.report-data-table tbody th.mdm-form-cell.sno-col {
  z-index: 12;
  background: rgb(255, 255, 255);
  box-shadow: none;
}

/* Freeze columns right after S.No (currently first two columns after S.No). */
.report-data-table thead th.sticky-follow-col,
.report-data-table tbody td.sticky-follow-col,
.report-data-table tbody th.mdm-form-cell.sticky-follow-col {
  position: sticky;
}

.report-data-table thead th.sticky-follow-col {
  z-index: 15;
  /* background: var(--mdm-header-bg); */
  box-shadow: none;
}

.report-data-table tbody td.sticky-follow-col {
  z-index: 11;
  background: #fff;
  box-shadow: none;
}

.report-data-table tbody th.mdm-form-cell.sticky-follow-col {
  z-index: 11;
  background: rgb(255, 255, 255);
  box-shadow: none;
}

/* Avoid bright vertical seams inside the sticky block (Action + S.No + follow sticky columns). */
/*
 * First scrollable column after the frozen block (last sticky-follow is immediately before it).
 * Extra left padding so content clears the sticky column edge and reads comfortably.
 */
.report-data-table thead th.sticky-follow-col + th:not(.sticky-follow-col),
.report-data-table tbody td.sticky-follow-col + td:not(.sticky-follow-col),
.report-data-table tbody th.mdm-form-cell.sticky-follow-col + th.mdm-form-cell:not(.sticky-follow-col) {
  border-left: 2px solid #cbd5e1 !important;
  padding-left: 1.15rem;
}

/* Edit / insert row: allow wrapping; stop selects from dictating huge column width */
.report-data-table tbody th.mdm-form-cell {
  white-space: normal;
  vertical-align: top;
  min-width: 0;
}

/* Select columns were collapsing to ~1ch wide (vertical letters); give a floor only on edit/insert rows */
.report-data-table tbody th.mdm-form-cell.mdm-form-cell--select {
  min-width: 11rem;
  width: auto;
}

.report-data-table tbody th.mdm-form-cell .form-control {
  max-width: 100%;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .v-select {
  width: 100%;
  min-width: 0;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .vs__dropdown-toggle {
  width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .vs__selected-options {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .vs__selected,
.report-data-table tbody th.mdm-form-cell .mdm-inline-select .vs__single-value {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .vs__dropdown-menu {
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .vs__dropdown-option {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.25;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .v-select.vs--open {
  position: relative;
  z-index: 50;
}

/*
 * Do NOT set overflow:visible on .report-table-wrapper when a select opens. Switching the
 * scrollport from overflow:auto to visible resets scrollLeft/scrollTop in browsers, so the
 * grid jumps back to the start horizontally. Menus use append-to-body instead of unclipping.
 */
.report-data-table tbody tr:has(.mdm-inline-select .v-select.vs--open) {
  position: relative;
  z-index: 100;
}

.report-data-table tbody th.mdm-form-cell.sticky-follow-col:has(.mdm-inline-select .v-select.vs--open),
.report-data-table tbody th.mdm-form-cell.sno-col:has(.mdm-inline-select .v-select.vs--open) {
  z-index: 120;
  isolation: isolate;
}

.report-data-table tbody th.mdm-form-cell .mdm-inline-select .v-select.vs--open .vs__dropdown-menu {
  z-index: 200;
  max-height: min(320px, 55vh);
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

body > .vs__dropdown-menu {
  z-index: 5000;
  max-height: min(320px, 55vh);
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

body > .vs__dropdown-menu .vs__dropdown-option {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.25;
}

.mdm-action-toolbar {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  align-items: center;
  max-width: 100%;
}

.mdm-action-toolbar-insert {
  flex-direction: row;
  gap: 4px;
  padding: 2px 0;
}

.mdm-toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.65rem;
  min-height: 1.65rem;
  padding: 0.26rem 0.38rem;
  border: none;
  border-radius: 7px;
  font-size: 0.72rem;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.mdm-toolbar-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.18);
  filter: brightness(1.03);
}

.mdm-toolbar-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.mdm-toolbar-btn:focus {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

.mdm-toolbar-btn:disabled,
.mdm-toolbar-btn[disabled] {
  cursor: not-allowed;
  opacity: 0.45;
  filter: grayscale(0.25);
  box-shadow: none;
  pointer-events: none;
}

.mdm-toolbar-btn:disabled:hover,
.mdm-toolbar-btn[disabled]:hover {
  transform: none;
}

.mdm-toolbar-btn-add {
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
}

.mdm-toolbar-btn-edit {
  background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
}

.mdm-toolbar-btn-save {
  background: linear-gradient(180deg, #22c55e 0%, #16a34a 100%);
  color: #fff;
}

.mdm-toolbar-btn-cancel {
  background: linear-gradient(180deg, #f87171 0%, #dc2626 100%);
  color: #fff;
}

.report-data-table thead .action-col {
  top: 0;
  left: 0;
  z-index: 15;
  background: var(--mdm-header-bg);
  box-shadow: 2px 0 0 #1f2937;
}

.report-data-table thead th {
  position: sticky;
  top: 0;
  z-index: 7;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0.45rem 0.5rem;
  color: #f8fafc;
  border-color: transparent;
  background: transparent;
}

.report-data-table thead tr.mdm-header-row th {
  position: sticky;
}

.report-data-table thead tr.mdm-header-row th::before {
  content: "";
  position: absolute;
  inset: 2px 0;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: var(--mdm-header-bg);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
  z-index: -1;
}

.mdm-sort-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.18rem;
  width: 1rem;
  height: 1rem;
  border-radius: 999px;
  text-decoration: none;
  transition: background-color 0.16s ease, transform 0.16s ease;
}

.mdm-sort-trigger:hover {
  background-color: rgba(255, 255, 255, 0.14);
  transform: translateY(-1px);
}

.mdm-sort-trigger:focus {
  outline: 2px solid rgba(191, 219, 254, 0.85);
  outline-offset: 1px;
}

.report-data-table thead tr th:first-child {
  border-top-left-radius: 10px;
}

.report-data-table thead tr th:last-child {
  border-top-right-radius: 0;
}

.report-filters {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
  gap: 8px 12px;
  align-items: end;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.filter-label {
  display: block;
  font-size: 0.62rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 3px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-item {
  min-width: 0;
  width: 100%;
}

.clear-filter-btn {
  align-self: end;
  justify-self: start;
  margin-bottom: 1px;
  padding: 0.28rem 0.65rem;
  font-size: 0.72rem;
  white-space: nowrap;
  border-radius: 6px;
}

.compact-multiselect {
  font-size: 13px;
  width: 100%;
}

.compact-multiselect ::v-deep .multiselect {
  min-height: 30px;
}

.compact-multiselect ::v-deep .multiselect__tags {
  min-height: 30px;
  max-height: 52px;
  padding: 3px 30px 3px 8px;
  overflow-y: auto;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.compact-multiselect ::v-deep .multiselect__select {
  height: 30px;
  width: 28px;
}

.compact-multiselect ::v-deep .multiselect__single,
.compact-multiselect ::v-deep .multiselect__placeholder {
  margin-bottom: 0;
  padding-top: 1px;
  font-size: 11px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  color: #64748b;
}

.compact-multiselect ::v-deep .multiselect__content-wrapper {
  max-height: 200px;
}

.report-table-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

.report-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.report-table-wrapper::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 8px;
}

.report-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}

@media (max-width: 1400px) {
  .report-filters {
    grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
    padding: 8px 10px;
    gap: 6px 10px;
  }

  .report-data-table th,
  .report-data-table td {
    font-size: 0.75rem;
    padding: 0.3rem 0.35rem;
  }
}

@media (max-width: 992px) {
  .card-header {
    flex-wrap: wrap;
    gap: 8px !important;
  }

  .card-header .flex-grow-0 {
    min-width: 100% !important;
    max-width: 100% !important;
  }

  .report-data-table th,
  .report-data-table td {
    font-size: 12px;
    padding: 0.45rem;
  }

  .report-filters {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}

@media (max-width: 576px) {
  .report-data-table {
    --mdm-action-col-width: 72px;
  }

  .report-data-table th,
  .report-data-table td {
    font-size: 11px;
    padding: 0.35rem;
  }

  .report-data-table .action-col {
    width: var(--mdm-action-col-width);
    min-width: var(--mdm-action-col-width);
    max-width: var(--mdm-action-col-width);
  }

  .mdm-toolbar-btn {
    min-width: 2.2rem;
    min-height: 2.2rem;
    padding: 0.4rem 0.45rem;
  }

  .report-filters {
    grid-template-columns: 1fr;
  }
}

.my-custom-tooltip {
  background-color: transparent !important; /* Semi-transparent background */
  padding: 15px !important; /* Increased padding for better spacing */
  border: none !important;
  box-shadow: none !important; /* Subtle shadow for depth */
}

.my-custom-tooltip .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1200px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}


@media (max-width: 1500px) and (min-width: 1301px) {
  .my-custom-tooltip .tooltip-inner {
    width: 950px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1300px) and (min-width: 1251px) {
  .my-custom-tooltip .tooltip-inner {
    width: 920px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1250px) and (min-width: 1201px) {
  .my-custom-tooltip .tooltip-inner {
    width: 870px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1200px) and (min-width: 1151px) {
  .my-custom-tooltip .tooltip-inner {
    width: 820px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1150px) and (min-width: 1101px) {
  .my-custom-tooltip .tooltip-inner {
    width: 770px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1100px) and (min-width: 1051px) {
  .my-custom-tooltip .tooltip-inner {
    width: 720px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1050px) and (min-width: 1001px) {
  .my-custom-tooltip .tooltip-inner {
    width: 670px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1000px) and (min-width: 951px) {
  .my-custom-tooltip .tooltip-inner {
    width: 620px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 950px) and (min-width: 901px) {
  .my-custom-tooltip .tooltip-inner {
    width: 570px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 900px) and (min-width: 851px) {
  .my-custom-tooltip .tooltip-inner {
    width: 520px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 850px) and (min-width: 801px) {
  .my-custom-tooltip .tooltip-inner {
    width: 470px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .my-custom-tooltip .tooltip-inner {
    width: 430px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 768px) and (min-width: 751px) {
  .my-custom-tooltip .tooltip-inner {
    width: 650px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 750px) and (min-width: 701px) {
  .my-custom-tooltip .tooltip-inner {
    width: 600px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 700px) and (min-width: 651px) {
  .my-custom-tooltip .tooltip-inner {
    width: 550px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 650px) and (min-width: 601px) {
  .my-custom-tooltip .tooltip-inner {
    width: 500px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 600px) and (min-width: 551px) {
  .my-custom-tooltip .tooltip-inner {
    width: 450px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 550px) and (min-width: 481px) {
  .my-custom-tooltip .tooltip-inner {
    width: 370px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .my-custom-tooltip .tooltip-inner {
    width: 350px; /* Further reduce the width for very small screens */
    font-size: 16px; /* Further adjust font size for very small screens */
  }

  .h1tag {
    font-size: 18px;
  }
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border: 1px solid black
}


</style>